/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccountListResyncRequest,
  GenerateOtpParams,
  OtpResponse,
  ResyncRequest,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Generate a one time password
 */
export const generateOtp = (
  params: GenerateOtpParams,
  options?: SecondParameter<typeof backofficeRequest<OtpResponse>>,
) => {
  return backofficeRequest<OtpResponse>(
    { url: `/admin/generate-otp`, method: "POST", params },
    options,
  )
}
/**
 * @summary Resynchronise an account with Junifer
 */
export const resyncAccount = (
  resyncRequest: ResyncRequest,
  options?: SecondParameter<typeof backofficeRequest<void>>,
) => {
  return backofficeRequest<void>(
    {
      url: `/admin/resync-account`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: resyncRequest,
    },
    options,
  )
}
/**
 * @summary Resynchronise a list of accounts with Junifer
 */
export const resyncAccounts = (
  accountListResyncRequest: AccountListResyncRequest,
  options?: SecondParameter<typeof backofficeRequest<void>>,
) => {
  return backofficeRequest<void>(
    {
      url: `/admin/resync-accounts`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: accountListResyncRequest,
    },
    options,
  )
}
export type GenerateOtpResult = NonNullable<
  Awaited<ReturnType<typeof generateOtp>>
>
export type ResyncAccountResult = NonNullable<
  Awaited<ReturnType<typeof resyncAccount>>
>
export type ResyncAccountsResult = NonNullable<
  Awaited<ReturnType<typeof resyncAccounts>>
>
